export default __webpack_public_path__ + "static/assets/10a6126b7bc54305463d0488d7b8c67e.svg";